// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
export const LANGUAGE_REGEX = /(^[a-z]{2}(-[a-z]{2})?)\//;
